import { Breadcrumb } from 'antd';
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PatientPageBreadCrumb = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Breadcrumb
      items={[
        {
          onClick: () => {
            navigate('/');
          },
          title: (
            <span style={{ cursor: 'pointer' }}>
              <HomeOutlined style={{ marginRight: 4 }} />
              <span>{t('breadcrumb.admin')}</span>
            </span>
          ),
        },
        {
          title: (
            <>
              <UserOutlined />
              <span>{t('breadcrumb.patient')}</span>
            </>
          ),
        },
      ]}
    />
  );
};
